import { FC, useMemo } from 'react'

import WildlifeFilterFormFields from './wildlife-filter-fields'

import { IWildlifeFilterFormProps } from './wildlife-filter-form-types'

const WildlifeFilterForm: FC<IWildlifeFilterFormProps> = props => {
  const { formName, handleSubmit, submitting, disabled, values } = props

  const isDisabled = useMemo(() => submitting || disabled, [submitting, disabled])

  return (
    <form onSubmit={handleSubmit} id={formName}>
      <WildlifeFilterFormFields disabled={isDisabled} values={values} />
    </form>
  )
}

export default WildlifeFilterForm
